import React from 'react'
import Select from 'react-select'
import { Button } from '../../../components'
import { RelatedItem } from './related-item';

const FormRelated = ({isMobile}) => {
  return (
    <div>
      <div className="mb-4 lg:mb-10">
        <p className="text-lg font-bold mb-5">Related Events</p>
        <div className="w-full flex flex-row items-center mb-4 lg:mb-5">
          <Select className="text-sm w-full lg:w-2/3 mr-4 lg:mr-2" options={[]} placeholder="Search Event" />
          <div style={{maxWidth: isMobile ? '25%' : '137px'}}>
            <Button
              thin
              className="w-full lg:w-auto h-full px-4"
            >
              Add
            </Button>
          </div>
        </div>
        <div className="flex flex-wrap -mx-2 lg:mx-0">
          <div className="w-1/2 lg:w-auto px-2 lg:px-0 lg:mr-2 mb-4 lg:mb-2">
            <RelatedItem value="Event A"/>
          </div>
          <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-4 lg:mb-2">
            <RelatedItem value="Event B"/>
          </div>
        </div>
      </div>

      <div className="mb-4 lg:mb-10">
        <p className="text-lg font-bold mb-5">Related Resources</p>
        <div className="w-full flex flex-row items-center mb-4 lg:mb-5">
          <Select className="text-sm w-full lg:w-2/3 mr-4 lg:mr-2" options={[]} placeholder="Search Resource" />
          <div style={{maxWidth: isMobile ? '25%' : '137px'}}>
            <Button
              thin
              className="w-full lg:w-auto h-full px-4"
            >
              Add
            </Button>
          </div>
        </div>
        <div className="flex flex-wrap -mx-2 lg:mx-0">
          <div className="w-1/2 lg:w-auto px-2 lg:px-0 lg:mr-2 mb-4 lg:mb-2">
            <RelatedItem value="Resource A"/>
          </div>
          <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-4 lg:mb-2">
            <RelatedItem value="Resource B"/>
          </div>
        </div>
      </div>

      <div className="mb-4 lg:mb-10">
        <p className="text-lg font-bold mb-5">Related Blog</p>
        <div className="w-full flex flex-row items-center mb-4 lg:mb-5">
          <Select className="text-sm w-full lg:w-2/3 mr-4 lg:mr-2" options={[]} placeholder="Search Blog" />
          <div style={{maxWidth: isMobile ? '25%' : '137px'}}>
            <Button
              thin
              className="w-full lg:w-auto h-full px-4"
            >
              Add
            </Button>
          </div>
        </div>
        <div className="flex flex-wrap -mx-2 lg:mx-0">
          <div className="w-1/2 lg:w-auto px-2 lg:px-0 lg:mr-2 mb-4 lg:mb-2">
            <RelatedItem value="Blog A"/>
          </div>
          <div className="w-1/2 lg:w-auto px-2 lg:px-0 mb-4 lg:mb-2">
            <RelatedItem value="Blog B"/>
          </div>
        </div>
      </div>
    </div>
  )
}

export { FormRelated }